import React, { Component } from 'react'; // eslint-disable-line
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import _actions from '../../actions';
import ValidatedInput from '../forms/ValidatedInput';
import ColorChoice from '../common/colorChoice';
import TapTypeSelector from './TapTypeSelector';

class TextContentEditor extends Component {
    render() {
        return (
            <div className="edit-text-content">
                <span className="preview">Preview</span>
                <div className="preview-block-text">
                    {/* eslint-disable */}
                    <h2
                        style={{color: this.props.contentModalContent.headerTextColor === 3 ? this.props.versions.select.primaryText : this.props.contentModalContent.headerTextColor === 4 ? this.props.versions.select.secondaryText : this.props.versions.select.accentColor }}
                        className={this.props.contentModalContent.headerSize === 1 ? 'small' : this.props.contentModalContent.headerSize === 2 ? 'medium' : 'large'}
                    >
                        {this.props.contentModalContent.headerText}
                    </h2>
                    <h3 style={{ color: this.props.contentModalContent.subheaderTextColor === 3 ? this.props.versions.select.primaryText : this.props.contentModalContent.subheaderTextColor === 4 ? this.props.versions.select.secondaryText : this.props.versions.select.accentColor }}>
                        {this.props.contentModalContent.subheaderText}
                    </h3>
                    <p style={{ color: this.props.contentModalContent.textColor === 3 ? this.props.versions.select.primaryText : this.props.contentModalContent.textColor === 4 ? this.props.versions.select.secondaryText : this.props.versions.select.accentColor }}>
                        {this.props.contentModalContent.text}
                    </p>
                    {/* eslint-enable */}
                </div>
                <div className="text-input-wrapper">
                    <ValidatedInput
                        containerClass="input_headerText"
                        labelText="Header"
                        value={this.props.contentModalContent.headerText}
                        name="headerText"
                        onChange={(e) => { return this.props.setStateFromEvent(e, 'headerText'); }}
                        errorMessage=""
                        hasError={false}
                        successMessage=""
                        hasSuccess={false}
                    />
                    <ColorChoice selected={this.props.contentModalContent.headerTextColor} containerId="headerTextColor" setColor={this.props.handleColorChange} />
                </div>
                <div className="text-input-wrapper">
                    <ValidatedInput
                        containerClass="input_subheaderText"
                        labelText="Sub-header"
                        value={this.props.contentModalContent.subheaderText}
                        name="subheaderText"
                        onChange={(e) => { return this.props.setStateFromEvent(e, 'subheaderText'); }}
                        errorMessage=""
                        hasError={false}
                        successMessage=""
                        hasSuccess={false}
                    />
                    <ColorChoice selected={this.props.contentModalContent.subheaderTextColor} containerId="subheaderTextColor" setColor={this.props.handleColorChange} />
                </div>
                <div className="text-input-wrapper">
                    <ValidatedInput
                        containerClass="input_Text"
                        labelText="Text"
                        value={this.props.contentModalContent.text}
                        name="text"
                        onChange={(e) => { return this.props.setStateFromEvent(e, 'text'); }}
                        errorMessage=""
                        hasError={false}
                        successMessage=""
                        hasSuccess={false}
                        multiline
                    />
                    <ColorChoice selected={this.props.contentModalContent.textColor} containerId="textColor" setColor={this.props.handleColorChange} />
                </div>
                <div className="header-size">
                    <h4>Header Size</h4>
                    <button type="button" className={`btn-design-system medium secondary icon ${this.props.contentModalContent.headerSize === 1 ? 'active' : ''}`} onClick={() => { this.props.changeFontSize(1); }}>S</button>
                    <button type="button" className={`btn-design-system medium secondary icon ${this.props.contentModalContent.headerSize === 2 ? 'active' : ''}`} onClick={() => { this.props.changeFontSize(2); }}>M</button>
                    <button type="button" className={`btn-design-system medium secondary icon ${this.props.contentModalContent.headerSize === 3 ? 'active' : ''}`} onClick={() => { this.props.changeFontSize(3); }}>L</button>
                </div>

                <TapTypeSelector updateTapTypeFromEvent={this.props.updateTapTypeFromEvent} contentModalContent={this.props.contentModalContent} formsItems={this.props.formsItems} formsObjects={this.props.formsObjects} pagesItems={this.props.pagesItems} setStateFromEvent={this.props.setStateFromEvent} />
            </div>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        ...state,
        ...ownProps,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        actions: bindActionCreators(_actions, dispatch),
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(TextContentEditor);
